import { ApplicationConfig, provideZoneChangeDetection, APP_INITIALIZER } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { CookieService } from 'ngx-cookie-service';
import { firstValueFrom } from 'rxjs';

import { routes } from './app.routes';
import { authInterceptor } from './Core/Auth/Interceptor/auth.interceptor';
import { ProfileService } from './Core/Profile/Service/profile.service';

/**
 * Initialize user profile on app startup if tokens exist
 * Runs before app bootstrap to ensure profile is loaded before any routes activate
 */
export function initializeProfile(
  profileService: ProfileService,
  cookieService: CookieService
) {
  return () => {
    const hasToken = !!(sessionStorage.getItem('access_token') || cookieService.get('access_token'));
    const userId = sessionStorage.getItem('user_id') || cookieService.get('user_id');
    
    if (hasToken && userId) {
      return firstValueFrom(profileService.fetchProfile(userId))
        .catch((error) => {
          console.error('Profile initialization failed:', error);
          // Defensive: ensure loading state is cleared in exceptional cases
          // (fetchProfile's catchError should normally handle this)
          profileService.setLoadingState(false);
          // Allow app to continue - user will be directed to login by guard
          return null;
        });
    }
    
    return Promise.resolve();
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes, withHashLocation()),
    provideHttpClient(
      withInterceptors([authInterceptor])
    ),
    provideAnimationsAsync(),
    CookieService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeProfile,
      deps: [ProfileService, CookieService],
      multi: true
    }
  ]
};
